import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Radar, ArrowRight } from 'lucide-react';
import axios from 'axios';
import '@/Radar.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('de-AT', { day: '2-digit', month: 'long', year: 'numeric' }) : '');

function RadarTeaser() {
  const [post, setPost] = useState(null);

  useEffect(() => {
    axios.get(`${API}/radar/posts`).then((r) => setPost(r.data[0] || null)).catch(() => {});
  }, []);

  if (!post) return null;
  const austria = (post.edition || 'world') === 'austria';

  return (
    <section className="radar-teaser-section" data-testid="radar-teaser-section">
      <div className="container">
        <h2 className="section-title"><Radar size={30} className="radar-icon" /> KI-Video Radar</h2>
        <p className="section-subtitle">Jede Woche: die wichtigsten KI-News mit Einordnung fürs Video-Marketing</p>
        <Link to={`/ki-news/${post.slug}`} className="radar-card radar-teaser-card" data-testid="radar-teaser-card">
          {post.has_image && <img src={`${API}/radar/image/${post.id}`} alt="" className="radar-teaser-img" loading="lazy" />}
          <div className="radar-card-meta">
            <span className={`radar-edition ${austria ? 'radar-edition-austria' : 'radar-edition-world'}`}>
              {austria ? '🇦🇹 Österreich Spezial' : '🌍 Weltweit'}
            </span>
            <span className="radar-week">Neueste Ausgabe · {post.week_label} · {fmtDate(post.published_at)}</span>
          </div>
          <h3 className="radar-teaser-title">{post.title}</h3>
          <p className="radar-teaser-intro">{post.intro}</p>
          <span className="radar-readmore">Ausgabe lesen →</span>
        </Link>
        <div className="radar-teaser-all">
          <Link to="/ki-news" className="radar-teaser-all-btn" data-testid="radar-teaser-all-btn">
            Alle Ausgaben ansehen <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default RadarTeaser;
